<template>
  <v-container>
    <div class="page">
      <div class="section-title">{{r.head}}</div>
      <p class="section-description">{{r.description}}</p>
      <div v-for="(item, index) in r.items" :key="index">
        <div class="section-second-title">{{ item.title }}</div>
        <div v-if="item.hasSubItems">
          <v-divider class="line"></v-divider>
          <div v-for="(sub, index) in item.subItems" :key="index">
            <div class="item-context">
              <div class="item-col-1">
                {{sub.title}}: {{sub.description}}
              </div>
              <v-btn   v-if="sub.downloadPDFName"  :disabled="!sub.disabled"  variant="tonal" color="info" class="mr-2" size="x-small" @click="download_pdf(sub.downloadPDFName)">Download</v-btn>
            </div>
            <v-divider class="line"></v-divider>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { getDownloadUrl } from '@/config'

export default {

  data() {
    return {
      r: {
        head: 'Python',
        description: 'Users can download the instructions for ExposomeX Python package "exposomex"',
        items: [{
          title: 'Handbook',
          hasSubItems: true,
          subItems: [{
            title: 'Handbook',
            description: 'Applied Exposomics Analysis Using exposomex in Python',
            downloadPDFName: 'exposomex_handbook.pdf',
            youTubeLink: '',
            bilibiliLink: '',
            disabled:false,
          }]
        },{
          title: 'User Manual',
          hasSubItems: true,
          subItems: [{
            title: 'User Manual',
            description: 'Package "exposomex"',
            downloadPDFName: 'exposomex_manual.pdf',
            youTubeLink: '',
            bilibiliLink: '',
            disabled:false,
          }]
        }]
      }
    };
  },
  methods: {
    async download_pdf(name) {
      let a = document.createElement('a')
      a.href = getDownloadUrl('pdf', name)
      a.target = '_blank'
      a.click()
    },
  }
};
</script>

<style scoped lang="scss">
.page {
  font-size: $webpage-base-font-size;
  margin-left: 2em;
}
p {
  text-indent: 0;
  text-align: left;
}
.section-title {
  font-size: $webpage-large-font-size;
  font-weight: bold;
  line-height: 1.4;
}
.section-second-title {
  font-weight: bold;
  margin: 0.6em 0 0.2em;
}
.section-description {
  margin-bottom: 0.8em;
}
.item-context {
  display: flex;
  gap: 60px;
  align-items: center;
  line-height: 1.6;
  margin: 0.2em 0;
  justify-content: start;
}
.item-col-1 {
  min-width: 800px;
}
.line {
  width: 90%;
}
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .line {
    width: 100%;
  }
  .item-col-1 {
    min-width: 0;
  }
  .item-context {
    justify-content: space-between;
  }
}
@media screen and (max-width: 600px) {
  .page {
    margin: 0;
  }
  .line {
    width: 100%;
  }
  .item-context {
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: space-between;
  }
  .item-col-1 {
    min-width: 0;
  }
}

</style>
